import React from 'react'
import { PieChart, Pie, Cell } from "recharts";
import { formatPrice } from '../../DocumentSection/utils/helper';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  payload 
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  let {value, type} = payload?.payload;
  return (
    <text
      x={x}
      y={y}
      fill="#8f8f8f"
      textAnchor={x > cx ? "middle" : "middle"}
      dominantBaseline="central"
      style={{fontWeight: 600}}
    >
      {`${(percent * 100).toFixed(0)}% (${type === "units" ? value : ("$" + (formatPrice({price: value}) || 0))})`}
    </text>
  );
};

export default function PieChartBos({pieChartData, label, totalValue}) {
    return (
        <div style={{width: "100%", height: "500px"}}>
          <div style={{padding: "5px 10px", fontSize: "16px", color: "#9a9a9a", textAlign: "center", fontWeight: 600}}>{label}: {(label === "Unit") ? totalValue : `$${formatPrice({price: totalValue}) || 0}`}</div>
          <PieChart width={400} height={400} style={{width: "100%", height: "inherit", fontSize: "18px"}}>
            <Pie
              data={pieChartData}
              cx={185}
              cy={160}
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={"85%"}
              fill="#8884d8"
              dataKey="value"
            >
              {pieChartData?.map((entry, index) => {
                return <Cell key={`cell-${index}`} fill={entry?.backgroundColor} />
              }
                
              )}
            </Pie>
          </PieChart>
        </div>
    );
}
